import { FeatureFlag } from '@ps/web-core-enums';
import React, { useState } from 'react';

import useFeature from '@swf/core/hooks/useFeature';

import RMFDepositLimitFields from './components/RMFDepositLimitFields/RMFDepositLimitFields';
import RMFDepositLimitsIntroduction from './components/RMFDepositLimitsIntroduction/RMFDepositLimitsIntroduction';

const RMFDepositLimit: React.FC = () => {
  const isSGScreenEnabled: boolean = useFeature(FeatureFlag.SwcSGScreen);

  const [isDepositLimitVisible, setDepositLimitVisibility] = useState(!isSGScreenEnabled);

  return isDepositLimitVisible ? (
    <RMFDepositLimitFields
      handleBackClick={isSGScreenEnabled ? () => setDepositLimitVisibility(false) : undefined}
    />
  ) : (
    <RMFDepositLimitsIntroduction setDepositLimits={() => setDepositLimitVisibility(true)} />
  );
};

RMFDepositLimit.displayName = 'RMFDepositLimit';

export default RMFDepositLimit;
